// extracted by mini-css-extract-plugin
var _1 = "tjs-data-preview-map__badge";
var _2 = "tjs-data-preview-map__map";
var _3 = "tjs-data-preview-map__placeholder";
var _4 = "tjs-data-preview-map__terria-preview";
var _5 = "tjs-data-preview-map__terria-preview";
export { _1 as "badge", _2 as "map", _3 as "placeholder", _4 as "terria-preview", _5 as "terriaPreview" }
export default { "badge": _1, "map": _2, "placeholder": _3, "terria-preview": _4, "terriaPreview": _5 }
